import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	productDetail: {
		"&[data-type='voucher']": {
			"& .mco-shop-product-detail-gallery": {
				maxWidth: 300,
				[theme.breakpoints.up("lg")]: {
					maxWidth: 350
				}
			}
		}
	},
	information: {
		marginBottom: theme.spacing(4),
		marginTop: -480
	},
	wrapper: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		minHeight: 380,
		position: "relative",
		[theme.breakpoints.up("md")]: {
			flexDirection: "row"
		}
	},
	left: {
		order: 3,
		paddingTop: theme.spacing(10),
		[theme.breakpoints.up("md")]: {
			flex: "0 0 33%",
			order: 1
		}
	},
	center: {
		display: "flex",
		justifyContent: "center",
		order: 1,
		position: "relative",
		"& .mco-shop-product-detail-gallery": {
			maxWidth: 115,
			width: "100%",
			"& .mco-gallery-02-swiper-nav__prev": {
				display: "none"
			},
			"& .mco-gallery-02-swiper-nav__next": {
				display: "none"
			},
			[theme.breakpoints.up("sm")]: {
				maxWidth: 150
			},
			[theme.breakpoints.up("md")]: {
				maxWidth: 200
			}
		},
		[theme.breakpoints.up("md")]: {
			flex: "0 0 33%",
			order: 2,
			position: "absolute",
			top: -350,
			left: "50%",
			transform: "translate(-50%, 0)"
		}
	},
	right: {
		order: 2,
		paddingTop: theme.spacing(10),
		[theme.breakpoints.up("md")]: {
			flex: "0 0 33%",
			order: 3
		}
	},
	price: {
		"& .mco-shop-price__value": {
			color: "#AFA08B",
			fontSize: "clamp(28px, 4vw, 48px)",
			lineHeight: 1.1
		}
	},
	attributes: {
		marginTop: theme.spacing(2)
	},
	itemNumber: {
		marginTop: theme.spacing(2)
	},
	preAnnouncement: {
		marginTop: theme.spacing(2)
	},
	rating: {
		marginTop: theme.spacing(2)
	},
	combinationSelection: {
		marginTop: theme.spacing(4)
	},
	buttons: {
		display: "flex",
		marginTop: theme.spacing(4),
		"& .mco-shop-product-detail-quantity": {
			marginRight: theme.spacing(2)
		},
		"& .mco-shop-product-detail-cart-button": {
			flex: 1
		}
	},
	descriptions: {
		marginTop: theme.spacing(10)
	},
	documents: {
		marginTop: theme.spacing(10)
	},
	ratings: {
		marginTop: theme.spacing(10)
	},
	recommendations: {
		marginTop: theme.spacing(10)
	}
}));

export default styles;
